import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { whitePvcDictVi } from "@/lib/shop/products/white-pvc";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/shop_/white-pvc")({
  head: () => ({
    ...buildProductHead(whitePvcDictVi),
    links: alternateLinkList("/shop/white-pvc", "vi"),
  }),
  component: () => <ProductPage dict={whitePvcDictVi} />,
});